import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { EmployeeService } from 'src/app/service/employee/employee.service';
import { AuthService } from 'src/app/service/auth.service';
import { Router } from '@angular/router';


@Component({
    selector: 'app-profilemenu',
    templateUrl: './app.profilesidebar.component.html'
})
export class AppProfileSidebarComponent {

    constructor(public layoutService: LayoutService,
                private employeeAuth: EmployeeService,
                private auth: AuthService,
                private router: Router
    ) { }

    isAdmin: boolean = false;
    loginAsDialogVisible: boolean = false;
    empleados: any[] = [];
    selectedEmpleado: any = null;
    filteredEmpleados: any[] = [];
    nombreEmpleadoActual: string = '';

    get visible(): boolean {
        return this.layoutService.state.profileSidebarVisible;
    }

    set visible(_val: boolean) {
        this.layoutService.state.profileSidebarVisible = _val;
    }

    ngOnInit() {
        this.auth.getEmployee().subscribe(
            employee => {
                this.isAdmin = employee.ROL_ID === 2;
            },
            err => {
                console.error('Error obteniendo empleado:', err);
            }
        );
    
        if (this.hayImpersonacion()) {
            
            const nombreCompleto = this.auth.getCurrentUserNameFromToken();
            if (nombreCompleto) {
                this.nombreEmpleadoActual = nombreCompleto;
            }
        }
    }
    
    

    perfil(){
        this.employeeAuth.getEmployeeID()
        .subscribe(
            res => {
              localStorage.setItem('empleado', res.EMPLEADO_ID);
              this.visible = false;
              this.router.navigate(['/empleados/perfil']);
            },
            err => {
                console.log(err);
              }
          );
    }

    logOut() {
        this.visible = false;
        this.auth.logOutUser();
        setTimeout(() => {
            window.location.reload();
        }, 100); // ⏳ Pequeño delay opcional para que cierre primero el sidebar
    }
    

    abrirLoginAs() {
        this.employeeAuth.getEmployee().subscribe({
            next: (res) => {
                const currentEmployeeId = this.auth.getEmployeeIdFromToken(); // 🔥 ID actual
                this.empleados = res
                    .filter((emp: any) => emp.EMPLEADO_ID !== currentEmployeeId)
                    .map((emp: any) => ({
                        ...emp,
                        fullName: `${emp.NOMBRE} ${emp.APELLIDO}` // 🔥 ARMA fullName AQUÍ
                    }));
    
                this.filteredEmpleados = [...this.empleados];
                this.loginAsDialogVisible = true;
            },
            error: (err) => {
                console.error('Error al traer empleados', err);
            }
        });
    }
    

    getClientes() {
        this.auth.getEmployee()
        .subscribe(
            res => {
            this.empleados = res;
            //this.loading = false;
            },
            err => {
            console.log(err);
            }
        );
    }

    confirmarLoginAs() {
        if (!this.selectedEmpleado?.EMPLEADO_ID) return;
        this.visible = false;
        // 🔥 Guarda tu token original antes de impersonar
        const currentToken = localStorage.getItem('token');
        if (currentToken) {
            localStorage.setItem('original_token', currentToken);
        }
    
        this.auth.loginAs(this.selectedEmpleado.EMPLEADO_ID).subscribe({
            next: (response) => {
                this.auth.saveToken(response.jwtToken);
                window.location.reload();
            },
            error: (error) => {
                console.error('Error haciendo login-as', error);
            }
        });
    }
    

    filtrarEmpleados(event: any) {
        const query = event.query ? event.query.toLowerCase() : '';
    
        this.filteredEmpleados = this.empleados.filter(emp => {
            const fullName = emp.fullName ? emp.fullName.toLowerCase() : '';
            return fullName.includes(query);
        });
    }
    
    volverAMiPerfilOriginal() {
        const originalToken = localStorage.getItem('original_token');
        if (originalToken) {
            this.visible = false;
            setTimeout(() => {
                this.auth.saveToken(originalToken);
                localStorage.removeItem('original_token');
                window.location.reload();
            }, 300); // 🕒 300ms también aquí
        } else {
            console.warn('No hay sesión original guardada.');
        }
    }


    hayImpersonacion() {
        return !!localStorage.getItem('original_token');
    }
    
    
}